/**
 * Marks a post-checkout destination with `welcome=true` — the flag `Home`
 * reads to show the download banner — without disturbing whatever else the
 * destination already carries.
 *
 * Existing query params are preserved and an existing `welcome` is
 * overwritten rather than duplicated. Relative destinations stay relative so
 * the locale-aware router can still prefix them; absolute ones (including
 * `hallow:` deep links) are returned whole.
 */
export const withWelcomeParam = (destination: string): string => {
  try {
    const url = new URL(destination, window.location.href);
    url.searchParams.set("welcome", "true");
    if (destination.startsWith("/"))
      return `${url.pathname}${url.search}${url.hash}`;
    return url.toString();
  } catch {
    return destination;
  }
};
